import { Company } from '@/api';
import { createContext } from 'react';

export interface CompaniesContextData {
    companies: Company[];
    companiesMap: Map<string, Company>;
}
export const CompaniesContext = createContext<CompaniesContextData | undefined>(
    undefined
);
